var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPorson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.07 11.8467C14.07 12.9899 13.1432 13.9167 12 13.9167C10.8568 13.9167 9.92999 12.9899 9.92999 11.8467C9.92999 10.7034 10.8568 9.77667 12 9.77667C13.1432 9.77667 14.07 10.7034 14.07 11.8467Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5388 1.79455C13.7701 2.02584 13.9 2.33955 13.9 2.66665V6.56665H10.1V2.66665C10.1 2.33955 10.2299 2.02584 10.4612 1.79455C10.6925 1.56325 11.0062 1.43331 11.3333 1.43331H12.6667C12.9938 1.43331 13.3075 1.56325 13.5388 1.79455Z",
    fill: "#0A0A0A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41665 18.4866H7.41667L7.41663 18.4808C7.41662 18.4806 7.41664 18.4804 7.41667 18.4802C7.9855 17.8469 8.68577 17.3453 9.46866 17.0105C10.2592 16.6724 11.1145 16.5127 11.9737 16.5429L12.001 16.5438L12.0282 16.5428C12.8861 16.5105 13.7405 16.6674 14.531 17.0023C15.3129 17.3337 16.0132 17.8313 16.5833 18.4604V18.4666V19.25H7.41665V18.4866Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7667 5.33333V5.23333H18.6667H15.4333V4.1H18.6667C18.9938 4.1 19.3075 4.22994 19.5388 4.46123C19.7701 4.69253 19.9 5.00623 19.9 5.33333V21.3333C19.9 21.6604 19.7701 21.9741 19.5388 22.2054C19.3075 22.4367 18.9938 22.5667 18.6667 22.5667H5.33333C5.00623 22.5667 4.69253 22.4367 4.46123 22.2054C4.22994 21.9741 4.1 21.6604 4.1 21.3333V5.33333C4.1 5.00623 4.22994 4.69253 4.46123 4.46123C4.69253 4.22994 5.00623 4.1 5.33333 4.1H8.56667V5.23333H5.33333H5.23333V5.33333V21.3333V21.4333H5.33333H18.6667H18.7667V21.3333V5.33333Z",
    fill: "#0A0A0A",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorson);
export default __webpack_public_path__ + "static/media/porson.95f6ec7b6394015d8fe410a6bcbe79ba.svg";
export { ForwardRef as ReactComponent };